import type { MonthlyTimelineItem } from './types';

export function flattenReleaseProjects(release: any): MonthlyTimelineItem[] {
  if (!release?.projects || !Array.isArray(release.projects)) {
    return [];
  }

  const flattenedItems: MonthlyTimelineItem[] = [];

  release.projects.forEach((quarterBucket: any) => {
    const bucketItems = Array.isArray(quarterBucket?.project)
      ? quarterBucket.project
      : [];

    bucketItems.forEach((item: any, index: number) => {
      const itemKey =
        item?.issueId ||
        item?.id ||
        `${release?.type || 'lane'}-${quarterBucket?.quarter || 'q'}-${index}`;

      flattenedItems.push({
        ...item,
        id: itemKey
      });
    });
  });

  return flattenedItems;
}
